// extracted by mini-css-extract-plugin
export default {"main":"CompletedTestBar_main__WRRE-","delete":"CompletedTestBar_delete__rP-Hr","download":"CompletedTestBar_download__Vgozu"};